import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

class NewPostButton extends Component {
  render() {
    if (
      (this.props.postId && this.props.postId === 'new') ||
      this.props.screen === 'bellOfMindfulness' ||
      this.props.screen === 'media' ||
      this.props.screen === 'pushNotifications'
    ) {
      return null;
    }

    return (
      <Button
        component={Link}
        to={`/${this.props.screen}/new`}
        color="primary"
      >
        <Icon>add</Icon> new post
      </Button>
    )
  }
}

export default NewPostButton;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/NewPostButton/index.js